





























import PartnerDetailAttributeWithToolTip from "@/components/partner/PartnerDetailAttributeWithToolTip.vue";
import RegistrationUpdateDialog from "@/components/utility/RegistrationUpdateDialog.vue";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { RegistrationResultsEntity } from "@/models/registrationResultsEntity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { Component, Prop } from "vue-property-decorator";
import Card from "../utility/Card.vue";
import TimelineCard from "../utility/TimelineItem.vue";

@Component({
  components: {
    PartnerDetailAttributeWithToolTip,
    RegistrationUpdateDialog,
    TimelineCard,
    Card
  }
})
export default class PartnerRegistrationTimeLineElement extends DarkModeHighlightMixin {
  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;
  @Prop()
  date!: string;

  @Prop()
  numberplate!: string;

  @Prop({ default: false })
  loading!: boolean;

  @Prop()
  registration!: RegistrationResultsEntity;

  @Prop({ default: "" })
  registrationImageLink!: string;

  update(registration: RegistrationResultsEntity) {
    this.$emit("update", registration);
  }

  get notEmptyData() {
    if (this.registrationData) {
      return this.registrationData.filter(item => !!item.show);
    }
    return [];
  }

  get headers() {
    return [
      { text: "Schlüssel", value: "key", width: 100, align: "start" },
      { text: "Wert", value: "value" }
    ];
  }

  get registrationData() {
    if (!this.registration || !this.numberplate) {
      return [];
    }
    return [
      {
        show: !!this.numberplate,
        key: this.$t("components.partner.PartnerRegistrationCard.numberplate"),
        value: this.numberplate
      },
      {
        show: !!this.registration?.name,
        key: this.$t("components.partner.PartnerRegistrationCard.name"),
        value: this.registration?.name
      },
      {
        show: !!this.registration?.firstname,
        key: this.$t("components.partner.PartnerRegistrationCard.firstname"),
        value: this.registration?.firstname
      },
      {
        show: !!this.registration?.identificationnumber,
        key: this.$t("components.partner.PartnerRegistrationCard.identificationnumber"),
        value: this.registration?.identificationnumber
      },
      {
        show: !!this.registration?.manufacturerNameCode,
        key: this.$t("components.partner.PartnerRegistrationCard.manufacturerNameCode"),
        value: this.registration?.manufacturerNameCode
      },
      {
        show: !!this.registration?.manufacturerTypeCode,
        key: this.$t("components.partner.PartnerRegistrationCard.manufacturerTypeCode"),
        value: this.registration?.manufacturerTypeCode
      },
      {
        show: !!this.registration?.firstregistrationDay,
        key: this.$t("components.partner.PartnerRegistrationCard.firstregistration"),
        value:
          this.registration?.firstregistrationDay +
          "." +
          this.registration?.firstregistrationMonth +
          "." +
          this.registration?.firstregistrationYear
      },
      {
        show: !!this.registration?.huMonth,
        key: this.$t("components.partner.PartnerRegistrationCard.hu"),
        value: this.registration?.huMonth + "." + this.registration?.huYear
      },
      {
        show: !!this.registration?.driveTyp,
        key: this.$t("components.partner.PartnerRegistrationCard.driveTyp"),
        value: this.registration?.driveTyp
      },
      {
        show: !!this.registration?.vehicleClass,
        key: this.$t("components.partner.PartnerRegistrationCard.vehicleClass"),
        value: this.registration?.vehicleClass
      },
      {
        show: !!this.registration?.manufacturerName,
        key: this.$t("components.partner.PartnerRegistrationCard.manufacturerName"),
        value: this.registration?.manufacturerName
      },
      {
        show: !!this.registration?.manufacturerType,
        key: this.$t("components.partner.PartnerRegistrationCard.manufacturerType"),
        value: this.registration?.manufacturerType
      },
      {
        show: !!this.registration?.manufacturerDescription,
        key: this.$t("components.partner.PartnerRegistrationCard.manufacturerDescription"),
        value: this.registration?.manufacturerDescription
      }
    ];
  }
}
